import { render, staticRenderFns } from "./bookerEdit.vue?vue&type=template&id=b06358f0&scoped=true&"
import script from "./bookerEdit.vue?vue&type=script&lang=js&"
export * from "./bookerEdit.vue?vue&type=script&lang=js&"
import style0 from "./bookerEdit.vue?vue&type=style&index=0&id=b06358f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06358f0",
  null
  
)

export default component.exports